const InventoryData = [
  // Pain & Fever
  { 
    batchNumber: 'B12345', 
    name: 'Paracetamol', 
    company: 'ABC Pharma', 
    orderedDate: new Date('2024-01-10').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2024-12-15').toLocaleDateString('en-GB'), 
    description: 'Pain relief, fever reduction. Effective in lowering body temperature and alleviating pain associated with fever.', 
    tags: ['pain', 'fever'], 
    ageGroup: 'adults-children', 
    tablets: 100, 
    totalPackets: 10, 
    pricePerPacket: 12.50, 
    pricePerTablet: 0.15, 
    totalCost: 125.00, 
    costPerDose: 0.15 
  },
  { 
    batchNumber: 'B56789', 
    name: 'Ibuprofen', 
    company: 'XYZ Health', 
    orderedDate: new Date('2024-02-05').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2024-10-05').toLocaleDateString('en-GB'), 
    description: 'Anti-inflammatory, pain relief. Used for treating inflammation and pain in conditions like arthritis, muscle strains, etc.', 
    tags: ['pain', 'fever'], 
    ageGroup: 'adults', 
    tablets: 120, 
    totalPackets: 12, 
    pricePerPacket: 18.00, 
    pricePerTablet: 0.20, 
    totalCost: 216.00, 
    costPerDose: 0.20 
  },

  // Allergy
  { 
    batchNumber: 'B23456', 
    name: 'Cetirizine', 
    company: 'HealthPlus', 
    orderedDate: new Date('2024-03-01').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2025-01-10').toLocaleDateString('en-GB'), 
    description: 'Allergy medication. Provides relief from sneezing, itching, and runny nose associated with allergies.', 
    tags: ['allergy'], 
    ageGroup: 'adults-children-6-years-and-older', 
    tablets: 90, 
    totalPackets: 9, 
    pricePerPacket: 9.50, 
    pricePerTablet: 0.12, 
    totalCost: 85.50, 
    costPerDose: 0.12 
  },
  { 
    batchNumber: 'B98881', 
    name: 'Fexofenadine', 
    company: 'ClearAir Pharma', 
    orderedDate: new Date('2024-03-15').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2025-04-05').toLocaleDateString('en-GB'), 
    description: 'Allergy medication. Effective in treating seasonal allergic rhinitis and chronic urticaria (hives).', 
    tags: ['allergy'], 
    ageGroup: 'adults-children-12-years-and-older', 
    tablets: 200, 
    totalPackets: 20, 
    pricePerPacket: 25.00, 
    pricePerTablet: 0.18, 
    totalCost: 500.00, 
    costPerDose: 0.18 
  },

  // Antibiotics
  { 
    batchNumber: 'B34567', 
    name: 'Amoxicillin', 
    company: 'MediCare', 
    orderedDate: new Date('2024-05-20').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2024-11-30').toLocaleDateString('en-GB'), 
    description: 'Antibiotic for bacterial infections. Used to treat a variety of bacterial infections, including respiratory and ear infections.', 
    tags: ['antibiotic', 'infection'], 
    ageGroup: 'adults-children', 
    tablets: 150, 
    totalPackets: 15, 
    pricePerPacket: 22.00, 
    pricePerTablet: 0.25, 
    totalCost: 330.00, 
    costPerDose: 0.25 
  },
  { 
    batchNumber: 'B89012', 
    name: 'Doxycycline', 
    company: 'CureAll Pharmaceuticals', 
    orderedDate: new Date('2024-06-10').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2024-12-25').toLocaleDateString('en-GB'), 
    description: 'Antibiotic for bacterial infections. Effective for treating bacterial infections like pneumonia, acne, and Lyme disease.', 
    tags: ['antibiotic', 'infection'], 
    ageGroup: 'adults', 
    tablets: 200, 
    totalPackets: 20, 
    pricePerPacket: 28.00, 
    pricePerTablet: 0.30, 
    totalCost: 560.00, 
    costPerDose: 0.30 
  },

  // Cough & Cold
  { 
    batchNumber: 'B45678', 
    name: 'Cough Syrup', 
    company: 'MedCo', 
    orderedDate: new Date('2024-08-01').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2025-03-20').toLocaleDateString('en-GB'), 
    description: 'Cough suppressant. Reduces coughing and provides relief from throat irritation and discomfort.', 
    tags: ['cough', 'cold'], 
    ageGroup: 'children-adults', 
    tablets: 50, 
    totalPackets: 5, 
    pricePerPacket: 7.50, 
    pricePerTablet: 0.30, 
    totalCost: 37.50, 
    costPerDose: 0.30 
  },
  { 
    batchNumber: 'B65432', 
    name: 'Cold & Flu Medicine', 
    company: 'FluCare', 
    orderedDate: new Date('2024-09-10').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2025-01-15').toLocaleDateString('en-GB'), 
    description: 'Cough suppressant and decongestant. Helps with nasal congestion and reduces coughing during flu season.', 
    tags: ['cough', 'cold'], 
    ageGroup: 'adults', 
    tablets: 180, 
    totalPackets: 18, 
    pricePerPacket: 15.00, 
    pricePerTablet: 0.25, 
    totalCost: 270.00, 
    costPerDose: 0.25 
  },

  // Seasonal Diseases
  { 
    batchNumber: 'B77654', 
    name: 'Cold Relief Tablets', 
    company: 'SeasonalCare', 
    orderedDate: new Date('2024-02-18').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2025-03-10').toLocaleDateString('en-GB'), 
    description: 'Seasonal flu and cold relief. Eases symptoms of the flu and seasonal cold, including fever and nasal congestion.', 
    tags: ['cold', 'fever'], 
    ageGroup: 'adults-children', 
    tablets: 250, 
    totalPackets: 25, 
    pricePerPacket: 20.00, 
    pricePerTablet: 0.18, 
    totalCost: 500.00, 
    costPerDose: 0.18 
  },
  { 
    batchNumber: 'B88901', 
    name: 'Vitamin C', 
    company: 'NutraHealth', 
    orderedDate: new Date('2024-07-15').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2025-06-01').toLocaleDateString('en-GB'), 
    description: 'Boosts immunity, prevents common cold. A powerful antioxidant that supports the immune system and promotes overall health.', 
    tags: ['cold', 'fever'], 
    ageGroup: 'adults-children', 
    tablets: 100, 
    totalPackets: 10, 
    pricePerPacket: 12.00, 
    pricePerTablet: 0.20, 
    totalCost: 120.00, 
    costPerDose: 0.20 
  },

  // Digestive
  { 
    batchNumber: 'B99881', 
    name: 'Omeprazole', 
    company: 'GastroMed', 
    orderedDate: new Date('2024-05-30').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2025-07-05').toLocaleDateString('en-GB'), 
    description: 'Acid reflux and indigestion treatment. Reduces stomach acid and helps in treating GERD, heartburn, and ulcers.', 
    tags: ['acid reflux', 'indigestion', 'stomach'], 
    ageGroup: 'adults', 
    tablets: 75, 
    totalPackets: 8, 
    pricePerPacket: 10.00, 
    pricePerTablet: 0.22, 
    totalCost: 80.00, 
    costPerDose: 0.22 
  },
  { 
    batchNumber: 'B12348', 
    name: 'Loperamide', 
    company: 'GutRelief', 
    orderedDate: new Date('2024-04-25').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2025-03-17').toLocaleDateString('en-GB'), 
    description: 'Anti-diarrheal. Used for controlling symptoms of diarrhea.', 
    tags: ['diarrhea', 'stomach'], 
    ageGroup: 'adults-children', 
    tablets: 100, 
    totalPackets: 10, 
    pricePerPacket: 8.00, 
    pricePerTablet: 0.15, 
    totalCost: 80.00, 
    costPerDose: 0.15 
  },

  // New additions
  { 
    batchNumber: 'B56432', 
    name: 'Aspirin', 
    company: 'PainRelief', 
    orderedDate: new Date('2024-10-01').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2025-09-15').toLocaleDateString('en-GB'), 
    description: 'Pain reliever and anti-inflammatory medication used to reduce pain and inflammation.', 
    tags: ['inflammation', 'pain'], 
    ageGroup: 'adults', 
    tablets: 200, 
    totalPackets: 20, 
    pricePerPacket: 15.00, 
    pricePerTablet: 0.18, 
    totalCost: 300.00, 
    costPerDose: 0.18 
  },
  { 
    batchNumber: 'B87654', 
    name: 'Lorazepam', 
    company: 'Anxiolytics Inc.', 
    orderedDate: new Date('2024-09-12').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2025-03-20').toLocaleDateString('en-GB'), 
    description: 'Anxiety medication used to treat anxiety disorders and provide sedation.', 
    tags: ['anxiety', 'sedative'], 
    ageGroup: 'adults', 
    tablets: 60, 
    totalPackets: 6, 
    pricePerPacket: 25.00, 
    pricePerTablet: 0.50, 
    totalCost: 150.00, 
    costPerDose: 0.50 
  },
  { 
    batchNumber: 'B43210', 
    name: 'Metformin', 
    company: 'DiabetesCare', 
    orderedDate: new Date('2024-06-18').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2025-05-01').toLocaleDateString('en-GB'), 
    description: 'Medication for type 2 diabetes. Helps control blood sugar levels in individuals with diabetes.', 
    tags: ['diabetes'], 
    ageGroup: 'adults', 
    tablets: 180, 
    totalPackets: 18, 
    pricePerPacket: 10.00, 
    pricePerTablet: 0.12, 
    totalCost: 180.00, 
    costPerDose: 0.12 
  },
  { 
    batchNumber: 'B90123', 
    name: 'Tamsulosin', 
    company: 'UroPharma', 
    orderedDate: new Date('2024-05-15').toLocaleDateString('en-GB'), 
    expiryDate: new Date('2025-04-10').toLocaleDateString('en-GB'), 
    description: 'Used to treat symptoms of benign prostatic hyperplasia (BPH) in men.', 
    tags: ['BPH'], 
    ageGroup: 'adults', 
    tablets: 90, 
    totalPackets: 9, 
    pricePerPacket: 20.00, 
    pricePerTablet: 0.25, 
    totalCost: 180.00, 
    costPerDose: 0.25 
  }
];

export default InventoryData;
